import React from 'react';
import { AlertTriangle, AlertOctagon, ChevronDown, ChevronRight } from 'lucide-react';
import { OrderTimelineProblemDto } from '../../../../../types/orderTimeline';
import { useTranslation } from '../../../../../contexts/I18nProvider';

interface TimelineProblemsProps {
  problems: OrderTimelineProblemDto[];
}

export const TimelineProblems: React.FC<TimelineProblemsProps> = ({ problems }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = React.useState(true);

  if (problems.length === 0) return null;

  const errors = problems.filter(p => p.severity === 'error');
  const warnings = problems.filter(p => p.severity === 'warning');

  return (
    <div className="mb-4">
      <button
        onClick={() => setExpanded(!expanded)}
        className="flex items-center gap-2 mb-2 text-sm font-semibold text-red-700 hover:text-red-800"
      >
        {expanded ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
        <AlertTriangle className="w-4 h-4" />
        {t('manager.modules.orderTimeline.problems.title', { '0': problems.length }, `Oppdagede problemer (${problems.length})`)}
      </button>
      {expanded && (
        <div className="space-y-2">
          {errors.map((problem, i) => (
            <div key={`err-${i}`} className="bg-red-50 border border-red-200 rounded-lg p-3">
              <div className="flex items-start gap-2">
                <AlertOctagon className="w-4 h-4 text-red-600 mt-0.5 flex-shrink-0" />
                <div>
                  <div className="text-sm font-semibold text-red-800">{problem.title}</div>
                  <div className="text-sm text-red-700 mt-0.5">{problem.description}</div>
                  {problem.details && (
                    <div className="text-xs text-red-500 mt-1 font-mono bg-red-100 p-1 rounded">{problem.details}</div>
                  )}
                </div>
              </div>
            </div>
          ))}
          {warnings.map((problem, i) => (
            <div key={`warn-${i}`} className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
              <div className="flex items-start gap-2">
                <AlertTriangle className="w-4 h-4 text-yellow-600 mt-0.5 flex-shrink-0" />
                <div>
                  <div className="text-sm font-semibold text-yellow-800">{problem.title}</div>
                  <div className="text-sm text-yellow-700 mt-0.5">{problem.description}</div>
                  {problem.details && (
                    <div className="text-xs text-yellow-500 mt-1 font-mono bg-yellow-100 p-1 rounded">{problem.details}</div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
